import React from "react";

export default function IconCopyClipboard({ size = 20, ...rest }) {
  return (
    <svg width={size} height={size} {...rest} viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 13.5C7.0875 13.5 6.73438 13.3531 6.44063 13.0594C6.14688 12.7656 6 12.4125 6 12V3C6 2.5875 6.14688 2.23438 6.44063 1.94063C6.73438 1.64688 7.0875 1.5 7.5 1.5H14.25C14.6625 1.5 15.0156 1.64688 15.3094 1.94063C15.6031 2.23438 15.75 2.5875 15.75 3V12C15.75 12.4125 15.6031 12.7656 15.3094 13.0594C15.0156 13.3531 14.6625 13.5 14.25 13.5H7.5ZM7.5 12H14.25V3H7.5V12ZM4.5 16.5C4.0875 16.5 3.73438 16.3531 3.44063 16.0594C3.14688 15.7656 3 15.4125 3 15V4.5H4.5V15H12.75V16.5H4.5Z" fill="currentColor"/>
    </svg>
  );
}
